import React, { PropsWithChildren } from 'react';
import { MaintenancePage } from '../pages/MaintenancePage';
import { useMaintenance } from '../hocs/MaintenanceContext';

export const MainOutlet: React.FC<PropsWithChildren> = ({ children }) => {
  const { showMaintenancePage } = useMaintenance();

  return showMaintenancePage ? <MaintenancePage /> : <>{children}</>;
};
